var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkcircleFilledBrand = function SvgCheckmarkcircleFilledBrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M6.177 13.82a.66.66 0 1 1 .933-.934l2.262 2.392 6.425-6.57a.66.66 0 0 1 .934.934l-6.892 7.036a.66.66 0 0 1-.933 0z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckmarkcircleFilledBrand;